import { IStore } from '../index'

export const getBoxBuyStatus = (store: IStore) => store.boxBuyIntegration.status
export const getBoxBuyLoading = (s: IStore) => s.boxBuyIntegration.loading
